import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Base64 } from 'js-base64';
import { Context } from '../controls/advanced-gridview/models/context';
import { FilterInfos } from '../controls/advanced-gridview/models/filter-infos';
import { SortInfos } from '../controls/advanced-gridview/models/sort-infos';
import { DefaultHttpService } from './default-http.service';

export class CrudService extends DefaultHttpService {
    public getListHttpOptions(
        context: Context,
        filters: FilterInfos[],
        generalFilters: FilterInfos[],
        sortInfos: SortInfos,
        parameters: Map<string, string | number | boolean>
    ): {
        headers?:
            | HttpHeaders
            | {
                  [header: string]: string | string[];
              };
        params?:
            | HttpParams
            | {
                  [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
              };
    } {
        let httpParams = new HttpParams();

        parameters.forEach((value, key) => {
            httpParams = httpParams.set(key, value);
        });

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                sort: this.getHeader(sortInfos),
                filters: this.getHeader(filters),
                generalFilters: this.getHeader(generalFilters),
                context: this.getHeader(context),
            }),
            params: httpParams,
        };

        return httpOptions;
    }

    public getExportHeader(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos): HttpHeaders {
        const headers = new HttpHeaders({
            sort: this.getHeader(sortInfos),
            filters: this.getHeader(filters),
            context: this.getHeader(context),
            generalFilters: this.getHeader(generalFilters),
        });

        return headers;
    }

    private getHeader(value: any) {
        return Base64.encode(JSON.stringify(value));
    }
}
